export default __webpack_public_path__ + "static/media/bgm.1020c826.mp3";